import graphqlClient from '~/graphql/graphqlClient';

export interface MutationDismissHeroArgs {
  playerId: string;
  heroHandle: string;
}

export interface DismissHeroResult {
  heroHandle: string;
  refund_pd: number;
  currency1: number;
  hero_roster: unknown;
  hero_builds: unknown;
  loadouts: unknown;
}

const mutation = `
mutation DismissHero(
  $playerId: String!
  $heroHandle: String!
) {
  dismissHero(
    playerId: $playerId
    heroHandle: $heroHandle
  ) {
    heroHandle
    refund_pd
    currency1
    hero_roster
    hero_builds
    loadouts
  }
}`;

export default async function mutationDismissHero(args: MutationDismissHeroArgs) {
  return await graphqlClient.request<DismissHeroResult>('dismissHero', mutation, args);
}

